<template>
  <div
    class="pointer-events-auto min-w-[260px] max-w-sm rounded-lg shadow-md px-4 py-3 flex items-start gap-3 animate-fade-in"
    :class="severityClass"
    role="status"
  >
    <div class="flex-1 text-sm">{{ toast.message }}</div>
    <button type="button" class="text-current/70 hover:text-current" :aria-label="t('common.close')" @click="emit('dismiss', toast.id)">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { ToastMessage } from '@/composables/useToast';

const props = defineProps<{ toast: ToastMessage }>();
const emit = defineEmits<{ dismiss: [id: string] }>();

const { t } = useI18n();

// Use the fully-opaque -50 tint instead of `*-600/10` (10% over transparent).
// The tinted-over-transparent variant rendered over busy backgrounds (modals,
// images, the topbar) left the text effectively unreadable.
const severityClass = computed((): string => {
  switch (props.toast.severity) {
    case 'success':
      return 'bg-success-50 text-success-900 border border-success-200';
    case 'warning':
      return 'bg-warning-50 text-warning-900 border border-warning-200';
    case 'danger':
      return 'bg-danger-50 text-danger-900 border border-danger-200';
    case 'info':
    default:
      return 'bg-primary-50 text-primary-900 border border-primary-200';
  }
});
</script>
